import { MainLayout } from "@/components/layout/MainLayout";
import { Helmet } from "react-helmet";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>SonicForge - AI Music Generation</title>
        <meta name="description" content="Create music with AI through natural conversation. Describe your vision and hear it come to life in real-time." />
      </Helmet>
      <MainLayout />
    </>
  );
};

export default Index;
